// Stub para @react-native-firebase/messaging no ambiente web.
// Push notifications nativas não existem no navegador, então tudo aqui é no-op.

type RemoteMessage = {data?: Record<string, any>}

const messagingInstance = {}

export function getMessaging() {
  return messagingInstance
}

export function getToken(_messaging?: unknown): Promise<string> {
  return Promise.resolve('')
}

export function registerDeviceForRemoteMessages(_messaging?: unknown): Promise<void> {
  return Promise.resolve()
}

export function subscribeToTopic(_messaging?: unknown, _topic?: string): Promise<void> {
  return Promise.resolve()
}

export function onNotificationOpenedApp(
  _messaging?: unknown,
  _handler?: (remoteMessage: RemoteMessage) => void,
) {
  return () => {}
}

export function getInitialNotification(_messaging?: unknown): Promise<RemoteMessage | null> {
  return Promise.resolve(null)
}
